module.exports = __webpack_public_path__ + "static/img/chairman.cf842aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chairman.jpg
// module id = e6+A
// module chunks = 1